import "core-js/modules/es.function.bind";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/web.timers";

var _this = this;

/*
Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry

Description:
*/
var waitUntil = function waitUntil(condition) {
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var times = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var extraTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var remaining = times;

  var waitUntilCondition = function waitUntilCondition(resolve, reject) {
    if (condition()) {
      setTimeout(function () {
        return resolve();
      }, extraTime);
    } else if (!remaining) {
      reject(new Error('timeout'));
    } else {
      remaining = remaining - 1;
      setTimeout(waitUntilCondition.bind(_this, resolve, reject), interval);
    }
  };

  return new Promise(waitUntilCondition);
};

export default waitUntil;